<template>
  <div>
    <b-row class="mb-1 align-items-stretch">
      <b-col md="6">
        <UserInfoSourcesCard
          title="Dari mana tau Miniapoly? "
          :items="infoSourcesItems"
          :loading="$store.state.userV2.loadingInfoSources"
          :total="$store.state.userV2.usersTotal || 0"
          left-title="Total Pengguna"
          total-unit="orang"
          :left-loading="$store.state.userV2.loadingUsersTotal"
          apex-height="230"
          donut-size="60%"
        />
      </b-col>
      <b-col md="6">
        <UserGrowthChart
          :chart-data="userGrowthData"
          type="buyer"
          :chart-height="240"
          :is-loading="isLoadingChart"
          :enable-range-picker="true"
        />
      </b-col>
    </b-row>
    <Table
      resource="UserV2"
      :detail-route="row => `/v2/users/${row.id}/detail`"
      :actions="actions"
      :items="$store.getters['userV2/tableData']"
      :detail="$store.getters['userV2/detailData']"
      :fields="$store.getters['userV2/tableFields']"
      :pagination="$store.state.userV2.tablePagination"
      :keyword="$store.state.userV2.tableKeyword"
      :loading="$store.state.userV2.loadingTable"
      :filter="$store.state.userV2.tableFilter"
      :sort="$store.state.userV2.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
      @export="onExportUsers"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/v2/Table.vue'
import UserGrowthChart from '@/@core/components/user/UserGrowthChart.vue'
import UserInfoSourcesCard from '@/components/user/UserInfoSourcesCard.vue'
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import { mapState } from 'vuex'

export default {
  components: {
    Table,
    UserGrowthChart,
    UserInfoSourcesCard,
    BRow,
    BCol,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'view',
        'update',
      ],
    }
  },
  computed: {
    ...mapState('user', ['userGrowth', 'isLoadingChart']),
    infoSourcesItems() {
      const rows = this.$store.state.userV2.infoSources || []
      return rows.map(r => ({ label: r.info_source, value: r.total }))
    },
    userGrowthData() {
      const growth = Array.isArray(this.userGrowth?.statistic) ? this.userGrowth.statistic : []
      return growth
    },
  },
  created() {
    // load donut data
    this.$store.dispatch('userV2/getInfoSources').catch(() => {})
    // load total pembeli
    this.$store.dispatch('userV2/getUsersTotal', { type: 'buyer' }).catch(() => {})
    // load growth chart data for buyer
    this.$store.dispatch('user/getChartUserRegistered', { interval: 'year', type: 'buyer' }).catch(() => {})
  },
  methods: {
    onExportUsers(done) {
      this.$store.dispatch('userV2/exportUsers', { type: 'buyer' })
        .then(rows => { if (typeof done === 'function') done(rows) })
        .catch(() => { if (typeof done === 'function') done(null) })
    },
    loadData() {
      return this.$store.dispatch('userV2/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('userV2/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('userV2/delete', id)
        .then(() => {
          callback()
        })
        .catch(err => {
          callback(err)
        })
    },
    resetDetail() {
      this.$store.commit('userV2/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('userV2/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('userV2/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('userV2/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('userV2/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('userV2/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('userV2/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
